import { useEffect, useState } from "react";
import './stylePortrait.css';
import './styleLandscape.css';

const Cargando = (props) => {

  const [dots, setDots] = useState('.');
  const { size, fase } = props




  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prev) => (prev === '...' ? '.' : prev + '.'));
    }, 300);

    return () => clearInterval(intervalId);
  }, []);



  return (
    <>
      {
        fase == "ingreso"
          ?
          <span
            data-fase={fase}
            className={`cargando text-white text-center mx-auto `}
            style={{
              backgroundColor: "#EF3CCD", border: 'none',
              clipPath: "polygon(5% 5%, 100% 0, 96% 100%, 0 96%)"
            }}
          >CARGANDO<span style={{ display: "inline-block", width: "20px" }}>{dots}</span></span>
          : fase == "registrar"
            ?
            <span
            data-fase={fase}
            className={`enviar text-white text-center mx-auto `}
            style={{
              backgroundColor: "#6093B8", border: 'none',
              clipPath: "polygon(5% 5%, 100% 0, 96% 100%, 0 96%)"
            }}
          >CARGANDO<span style={{ display: "inline-block", width: "20px" }}>{dots}</span></span>
            :
            <span
              data-fase={fase}
              className={`px-4 py-1 ${size === "md" ? "spanMedium" : size === "lg" ? "spanLarge" : "parrafoMD"}  mt-4`}
              style={{ backgroundColor: "#6093B8", color: "#fff", border: 'none', clipPath: "polygon(0 18%, 100% 0, 94% 100%, 5% 88%)" }}>CARGANDO<span style={{ display: "inline-block", width: "20px" }}>{dots}</span></span>
      }
    </>
  );
}
export default Cargando;